export default __webpack_public_path__ + "static/media/home-design-agency-img-06.95b5b8b7.jpg";